import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSelectedComponent, updateComponent } from '../../../redux/editorSlice';
import { PaddingControl, BorderRadiusControl, StyleControl } from '../CommonProperties';

const CustomMembershipSignupProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const dispatch = useDispatch();
  
  // 컴포넌트 속성 변경 핸들러
  const handleComponentPropsChange = (property, value) => {
    const existingProps = JSON.parse(JSON.stringify(selectedComponent.componentProps || {}));
    existingProps[property] = value;
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        componentProps: existingProps
      }
    }));
  };

  return (
    <>
      
      
      <div className="property-group">
        <div className="property-group-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          자유 멤버십 가입 설정
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>결제 가능한 자산</label>
          <div style={{ width: '100%' }}>
            {(selectedComponent.componentProps?.assetOptions || []).map((opt, idx) => (
              <div key={idx} style={{ display: 'flex', gap: 4, marginBottom: 4 }}>
                <input
                  type="text"
                  placeholder="자산 ID"
                  value={opt.id || ''}
                  onChange={e => {
                    const newOptions = [...(selectedComponent.componentProps?.assetOptions || [])];
                    newOptions[idx] = { ...newOptions[idx], id: e.target.value };
                    handleComponentPropsChange('assetOptions', newOptions);
                  }}
                  style={{ width: '30%' }}
                />
                <button type="button" onClick={() => {
                  const newOptions = [...(selectedComponent.componentProps?.assetOptions || [])];
                  newOptions.splice(idx, 1);
                  handleComponentPropsChange('assetOptions', newOptions);
                }}>삭제</button>
              </div>
            ))}
            <button type="button" onClick={() => {
              const newOptions = [...(selectedComponent.componentProps?.assetOptions || []), { id: '', name: '' }];
              handleComponentPropsChange('assetOptions', newOptions);
            }}>+ 자산 추가</button>
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>상품 ID</label>
          <input 
            type="number" 
            min="1"
            value={selectedComponent.componentProps?.productId || ""} 
            onChange={(e) => {
              const value = e.target.value;
              const numValue = value ? parseInt(value, 10) : 0;
              handleComponentPropsChange('productId', numValue);
            }}
            style={{ width: '100%' }}
            placeholder="예: 58"
          />
          <div className="property-description">
            사용할 상품의 ID를 입력하세요. (API 호출 시 products/ID 형식으로 사용됩니다)
          </div>
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>제목</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.title || '자유 멤버십 가입'} 
            onChange={(e) => handleComponentPropsChange('title', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>설명</label>
          <textarea 
            value={selectedComponent.componentProps?.description || '직접 금액을 입력해 가입/추가 결제할 수 있습니다.'} 
            onChange={(e) => handleComponentPropsChange('description', e.target.value)}
            style={{ width: '100%', minHeight: '60px' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>버튼 텍스트</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.buttonText || '가입/추가 결제'} 
            onChange={(e) => handleComponentPropsChange('buttonText', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>완료 텍스트</label>
          <input 
            type="text" 
            value={selectedComponent.componentProps?.completedText || '추가 결제가 완료되었습니다.'} 
            onChange={(e) => handleComponentPropsChange('completedText', e.target.value)}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>환급 시각화</label>
          <input 
            type="checkbox" 
            checked={selectedComponent.componentProps?.showRefundVisualization !== false}
            onChange={(e) => handleComponentPropsChange('showRefundVisualization', e.target.checked)}
          />
        </div>

        <div className="property-row">
          <label style={{ minWidth: '30%' }}>재가입 허용</label>
          <input 
            type="checkbox" 
            checked={selectedComponent.componentProps?.allowRejoin !== false}
            onChange={(e) => handleComponentPropsChange('allowRejoin', e.target.checked)}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>환급 한도 퍼센트</label>
          <input 
            type="number" 
            min="1"
            value={selectedComponent.componentProps?.refundLimitPercent || 400} 
            onChange={(e) => handleComponentPropsChange('refundLimitPercent', parseInt(e.target.value, 10))}
            style={{ width: '100%' }}
          />
        </div>
        
        <div className="property-row">
          <label style={{ minWidth: '30%' }}>최소 가입 가능 금액</label>
          <input 
            type="number" 
            min="1"
            value={selectedComponent.componentProps?.minAmount || 10000} 
            onChange={(e) => handleComponentPropsChange('minAmount', parseInt(e.target.value, 10))}
            style={{ width: '100%' }}
          />
        </div>
      </div>
      

    </>
  );
};

export default CustomMembershipSignupProperties; 